const getRetailDiscount = (discounts) => discounts.find(d => d.scope === 'RETAIL');
export { getRetailDiscount, };
